import StickySidebar from "accountOwner/pages/Scheduler/components/StickySidebar";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import styles from "../OfficeStaffInformation.module.scss";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useTranslation } from "react-i18next";
import { useStaffDesignation } from "repositories/scheduler-repository";
import OfficeFilter from "accountOwner/pages/Scheduler/components/SchedulerFilters/OfficeFilter";
const SideBarWrapper = ({
  applyFilter,
  resetFilter,
  handleSidebarToggle,
  children,
  isSidebarActive,
  officeTabNotActive,
  setOfficeListShow,
  cacheOffices,
  cacheRoles,
}) => {
  const { t } = useTranslation();
  const [selectedOfficeFilter, setOfficeFilter] = useState(cacheOffices ?? []);
  const [selectedRole, setSelectedRole] = useState(cacheRoles ?? []);
  const { selectedId } = useAccountOwnerCommon();
  const { data: DashBoardRoleData } = useStaffDesignation(
    {},
    {
      enabled: officeTabNotActive,
    }
  );
  const rolesData = useMemo(
    () => DashBoardRoleData?.map((item) => item?.designations)?.flat() || [],
    [DashBoardRoleData]
  );
  const handleChange = (e, item) => {
    const roles = [...selectedRole];

    const oIndex = roles.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      roles.push(item.id);
    } else {
      if (oIndex > -1) roles.splice(oIndex, 1);
    }
    setSelectedRole(roles);
  };
  const reset = useCallback(() => {
    setOfficeFilter([]);
    resetFilter();
    setSelectedRole([]);
  }, []);
  const preservedRef=useRef(null);
  useEffect(() => {
    if(selectedId){
      if(preservedRef.current===null){
        preservedRef.current=selectedId;
      }else if(preservedRef.current!==selectedId){
        reset();
        preservedRef.current=selectedId;
      }
    }
  }, [selectedId]);
  const isFilterApply =
    cacheOffices?.length || (officeTabNotActive && cacheRoles?.length);
  return (
    <div className="scheduler-tabs-main-wrapper">
      <StickySidebar
        isSidebarActive={isSidebarActive}
        handleSidebarToggle={handleSidebarToggle}
        resetFilter={reset}
      >
        <span className={styles.notes_filter}>
          {t("notes.filters")}
          {!!isFilterApply && <span className={styles.red_dot}></span>}
        </span>
        <Accordion
          preExpanded={["a", "b"]}
          className="filter-accordion"
          allowZeroExpanded
          allowMultipleExpanded
        >
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>{t("offices")}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <OfficeFilter
                selectedOffice={selectedOfficeFilter}
                setOfficeFilter={setOfficeFilter}
                selectedOwnerId={selectedId}
                includeOwnerOffices
                setOfficeListShow={setOfficeListShow}
                allElement={(officesData) =>
                  officesData?.length > 0 && (
                    <li>
                      <div className="ch-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            onChange={() => {
                              setOfficeFilter([]);
                            }}
                            checked={selectedOfficeFilter.length === 0}
                          />{" "}
                          <span>{t("all")} </span>
                        </label>
                      </div>
                    </li>
                  )
                }
              />
            </AccordionItemPanel>
          </AccordionItem>
          {officeTabNotActive && (
            <AccordionItem uuid="b">
              <AccordionItemHeading>
                <AccordionItemButton>{t("roles")}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className={["filter-list"]}>
                  {rolesData?.length > 0 && (
                    <li>
                      <div className="ch-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            onChange={() => {
                              setSelectedRole([]);
                            }}
                            checked={selectedRole.length === 0}
                          />{" "}
                          <span>{t("all")} </span>
                        </label>
                      </div>
                    </li>
                  )}
                  {rolesData.map((item) => (
                    <li key={item.id}>
                      <div className="ch-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            onChange={(e) => handleChange(e, item)}
                            checked={selectedRole.includes(item.id)}
                          />{" "}
                          <span> {item.name}</span>
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </AccordionItemPanel>
            </AccordionItem>
          )}
        </Accordion>

        <div className="filter-btn-box filter-btn-box--sticky-footer ">
          <button
            className={"button button-round button-shadow mr-3"}
            title={t("apply")}
            onClick={() => {
              applyFilter(selectedOfficeFilter, selectedRole);
            }}
          >
            {t("apply")}
          </button>
          <button
            className={
              "button button-round button-border button-dark reset-btn"
            }
            title={t("reset")}
            onClick={reset}
          >
            {t("reset")}
          </button>
          <button
            className={
              "button button-round button-border button-dark cancel-btn"
            }
            title={t("close")}
            onClick={handleSidebarToggle}
          >
            {t("close")}
          </button>
        </div>
      </StickySidebar>
      <div className="tabs-right-col" id="targetElementId">
        {children}
      </div>
    </div>
  );
};
export default SideBarWrapper;
